import styled, {css} from 'styled-components';

interface ItemProps {
  readonly text?: string;
  readonly size?: string;
  readonly font?: string;
  readonly color?: string;
  readonly family?: string;
  readonly weight?: string;
  readonly checked?: boolean;
}

export const BadgeContainer = styled.div<ItemProps>`
  font-family: 'Bree Serif';
  color: var(--BackgroundColor);
  justify-content: center;
  display: inline-flex;
  align-items: center;
  text-align: center;
  border-radius: 50%;
  position: relative;

  & span.initial {
    font-size: 20px;
    color: rgba(255, 255, 255, .4);
  }

  & span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ${props => {
    const color = props.color ? `background-color: ${props.color};` : '';
    const font = `font-size: ${props.font};`;
    const size = `
    width: ${props.size};
    height: ${props.size};`;
    const family = `font-family: '${props.family}';`;
    const weight = `font-weight: ${props.weight};`;
    const outLine = props.checked && `box-shadow: 0px 0px 0px 2px #fff,0px 0px 0px 3.25px  ${props.color};`;
    return css`
       {
        ${size}
        ${font}
        ${color}
        ${family}
        ${weight}
        ${outLine}
      }
    `;
  }};
  &:hover {
    border-radius: 50%;
    
`;
export const IconContainer = styled.div`
  align-self: center;
  text-align: center;
  line-height: 0;
`;
